import type { MainModule } from './MatSDK';
import loadModule from './MatSDK.js';
import moduleUrl from './MatSDK.wasm?url';

const _instance: Record<string, unknown> = {};

export async function loadWasmModule(): Promise<void> {
  const instance = await loadModule({ locateFile: () => moduleUrl });
  _instance._module = instance;
  Object.assign(_instance, instance);
}

export default _instance as unknown as MainModule;

export * from './MatSDK';
